import React from 'react';
import {
  BREEDER_SELLER_DEFAULT_IMAGE,
  PROFILES_ADMIN_PREFIX,
} from '../../../../utils/constants';
import routes from '../../../../utils/routes';
import { cloudinaryTransform } from '../../../../utils/cloudinaryTransformations';
import { setFallbackImage } from '../../../../utils/imageHelper';
import PhoneNumber from '../../admin-dashboard-tables/assets/PhoneNumber';

interface Props {
  id: string|number,
  profile_photo_url: string|null,
  name: string,
  slug: string,
  route: string,
  phone: string|number,
  primary_name: string,
  primary_phone: string|number,
  primary_method: Array<string>,
  onDelete: () => void,
}

const ProfileHit: React.FC<Props> = ({
  id,
  profile_photo_url,
  name,
  primary_name,
  primary_phone,
  primary_method,
  onDelete,
  slug,
  route,
}) => {
  const profilePhoto = profile_photo_url || BREEDER_SELLER_DEFAULT_IMAGE;
  return (
    <>
      <div className="seller-profile-card lh-1">
        <div className="image-container my-auto">
          <img
            alt={name}
            src={cloudinaryTransform(
              profilePhoto,
              [
                'c_fill',
                'h_26,w_26',
                'f_auto,q_auto',
              ],
            )}
            onError={(e) => {
              setFallbackImage(e, BREEDER_SELLER_DEFAULT_IMAGE);
            }}
            className="rounded"
          />
        </div>
        <div className="w-100">
          <a
            href={route}
            className="m-0 puppy-name"
          >
            {name}
          </a>
          <div className="d-flex justify-content-between my-auto">
            {primary_name
              ? (
                <div>
                  <p className="m-0 text-muted">
                    <small>
                      {`Primary Contact: ${primary_name}`}
                    </small>
                  </p>
                  <p className="text-muted m-0">
                    {
                      !!primary_phone && (
                        <small>
                          <i className="fas fa-phone-alt" />
                          <PhoneNumber
                            phone={primary_phone}
                            linkClassName="text-decoration-none seller-contact color-txt"
                            textClassName="text-decoration-none seller-contact color-txt"
                          />
                        </small>
                      )
                    }
                  </p>
                </div>
              ) : (
                <div>
                  <p className="m-0 text-muted"><small>Primary Contact: None</small></p>
                </div>
              )}
            <div className="d-flex align-self-start">
              <a
                className="m-2 btn badge badge-pill badge-blue-200 font-family-sans-serif border"
                href={routes.adminSellerContactsIndex(slug)}
              >
                <i className="fas fa-address-card" />
                Manage Contacts
              </a>
              <a
                href={`${PROFILES_ADMIN_PREFIX}/${id}/edit`}
                className="m-2 btn badge badge-pill badge-blue-200 font-family-sans-serif border"
              >
                <i className="fas fa-edit" />
                Edit Profile
              </a>
              {/* TODO: hook up delete button */}
              <button
                className="m-2 btn badge badge-pill text-danger"
                onClick={onDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileHit;
